(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discount-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-discount-code')) {
    class CartDiscountCode extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-discount-form]');
        this.input = this.querySelector('[data-discount-input]');
        this.message = this.querySelector('[data-discount-message]');
        this.submitBtn = this.querySelector('[data-discount-submit]');
        this.onSubmit = this.onSubmit.bind(this);
        this.onClick = this.onClick.bind(this);
        if (this.form) this.form.addEventListener('submit', this.onSubmit);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        this.removeEventListener('click', this.onClick);
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.classList.contains('is-loading')) return;
        const code = ((this.input && this.input.value) || '').trim();
        if (!code) {
          this.showError();
          return;
        }
        this.updateDiscount(code);
      }

      onClick(event) {
        const removeBtn = event.target.closest('[data-discount-remove]');
        if (!removeBtn || !this.contains(removeBtn)) return;
        event.preventDefault();
        if (this.classList.contains('is-loading')) return;

        const removed = (removeBtn.getAttribute('data-code') || '').trim();
        const remaining = this.appliedCodes()
          .filter((code) => code.toUpperCase() !== removed.toUpperCase())
          .join(',');
        this.updateDiscount(remaining);
      }

      appliedCodes() {
        return (this.getAttribute('data-applied-codes') || '')
          .split(',')
          .map((code) => code.trim())
          .filter(Boolean);
      }

      cartUpdateUrl() {
        const routes = (window.theme && window.theme.routes) || {};
        if (routes.cart_update_url) return `${routes.cart_update_url}.js`;
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return `${root}cart/update.js`;
      }

      codeEntry(entry) {
        if (typeof entry === 'string') return { code: entry, applicable: true };
        return {
          code: (entry && entry.code) || '',
          applicable: !entry || entry.applicable !== false
        };
      }

      // Cart Ajax `discount` replaces the whole code list; invalid codes often still return 200.
      isCodeApplicable(cart, code) {
        const wanted = code.toUpperCase();
        const codes = (cart && Array.isArray(cart.discount_codes)) ? cart.discount_codes : [];
        const match = codes.find((entry) => this.codeEntry(entry).code.toUpperCase() === wanted);
        if (!match) return false;
        return this.codeEntry(match).applicable;
      }

      showError() {
        if (!this.message) return;
        this.message.hidden = false;
        this.message.textContent = this.getAttribute('data-error-message') || '';
        if (this.input) {
          this.input.classList.add('invalid');
          this.input.setAttribute('aria-invalid', 'true');
          this.input.focus();
        }
      }

      clearError() {
        if (this.message) {
          this.message.hidden = true;
          this.message.textContent = '';
        }
        if (this.input) {
          this.input.classList.remove('invalid');
          this.input.removeAttribute('aria-invalid');
        }
      }

      setLoading(isLoading) {
        this.classList.toggle('is-loading', isLoading);
        this.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        if (this.submitBtn) this.submitBtn.disabled = isLoading;
        if (this.input) this.input.disabled = isLoading;
      }

      async postDiscount(discount) {
        const response = await fetch(this.cartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ discount })
        });
        const cart = await response.json();
        if (!response.ok) {
          throw new Error((cart && (cart.description || cart.message)) || 'Cart update failed');
        }
        return cart;
      }

      async updateDiscount(code, options) {
        const opts = options || {};
        this.clearError();
        this.setLoading(true);

        try {
          const cart = await this.postDiscount(code);
          const applyingCode = Boolean(code);
          const ok = !applyingCode || this.isCodeApplicable(cart, code);

          if (!ok) {
            const previous = this.appliedCodes().join(',');
            // Re-apply previous codes because `discount` is a full replace, not an add.
            if (opts.restoreOnFail !== false && previous && previous.toUpperCase() !== code.toUpperCase()) {
              await this.postDiscount(previous);
            }
            this.setLoading(false);
            if (this.input) this.input.disabled = false;
            this.showError();
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          this.setLoading(false);
        } catch (error) {
          this.setLoading(false);
          if (this.input) this.input.disabled = false;
          this.showError();
        }
      }
    }

    customElements.define('cart-discount-code', CartDiscountCode);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-freight-receiving"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__freightReceivingBound) return;
    window.__freightReceivingBound = true;

    const DESKTOP_MQ = window.matchMedia('(min-width: 768px)');

    const isDesktop = () => DESKTOP_MQ.matches;

    const getRoot = (el) => el && el.closest('[data-freight-receiving]');

    const closeModal = (root) => {
      if (!root) return;
      const modal = root.querySelector('[data-fr-modal]');
      const body = root.querySelector('[data-fr-modal-body]');
      if (!modal) return;
      modal.hidden = true;
      if (body) body.innerHTML = '';
      root.querySelectorAll('.freight-receiving__trigger[aria-expanded="true"]').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });
      document.documentElement.style.overflow = '';
    };

    const openModal = (root, trigger) => {
      const modal = root.querySelector('[data-fr-modal]');
      const body = root.querySelector('[data-fr-modal-body]');
      const src = trigger.closest('.freight-receiving__details')?.querySelector('.freight-receiving__modal-src');
      if (!modal || !body || !src) return;
      body.innerHTML = src.innerHTML;
      modal.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      const closeBtn = modal.querySelector('.freight-receiving__modal-close');
      if (closeBtn) closeBtn.focus();
    };

    document.addEventListener('click', (e) => {
      const closeEl = e.target.closest('[data-fr-close]');
      if (closeEl) {
        closeModal(getRoot(closeEl));
        return;
      }

      const trigger = e.target.closest('[data-fr-details]');
      if (!trigger) return;

      if (isDesktop()) {
        e.preventDefault();
        return;
      }

      e.preventDefault();
      const root = getRoot(trigger);
      if (!root) return;
      const modal = root.querySelector('[data-fr-modal]');
      const alreadyOpen = modal && !modal.hidden;
      if (alreadyOpen) {
        closeModal(root);
      } else {
        openModal(root, trigger);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-freight-receiving]').forEach((root) => closeModal(root));
    });

    const onBreakpointChange = () => {
      document.querySelectorAll('[data-freight-receiving]').forEach((root) => closeModal(root));
    };

    if (DESKTOP_MQ.addEventListener) {
      DESKTOP_MQ.addEventListener('change', onBreakpointChange);
    } else if (DESKTOP_MQ.addListener) {
      DESKTOP_MQ.addListener(onBreakpointChange);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
